import { render, staticRenderFns } from "./GoalHeader.vue?vue&type=template&id=209c7936&"
import script from "./GoalHeader.vue?vue&type=script&lang=js&"
export * from "./GoalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports